import { render, staticRenderFns } from "./OfficialFeePaymentInstitutionList.vue?vue&type=template&id=5bed338a&"
import script from "./OfficialFeePaymentInstitutionList.vue?vue&type=script&lang=js&"
export * from "./OfficialFeePaymentInstitutionList.vue?vue&type=script&lang=js&"
import style0 from "./OfficialFeePaymentInstitutionList.vue?vue&type=style&index=0&id=5bed338a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports